AuthRoute = require 'mixins/authenticated-route'

App.CategoriesCreateRoute = Em.Route.extend AuthRoute,
  controllerName: 'categoryEdit'

  model: ->
    organization = @controllerFor('categories').get('organization')

    @store.createRecord 'draft_category',
      name          : Em.I18n.t 'category_edit.new'
      menu_order    : null
      parent        : null
      is_hidden     : false
      is_list       : false
      organization  : organization

  setupController: (controller, model)->
    @_super(arguments...)
    controller.set('category', model)

  renderTemplate: (controller, model) ->
    @render 'categories.edit', controller: controller

